import { SparklesIcon } from "@heroicons/react/24/solid";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-amazon-dark via-amazon-dark-light to-amazon-dark-lighter py-16 sm:py-24">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-amazon-orange/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-amazon-orange/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-amazon-orange/20 text-amazon-orange px-4 py-2 rounded-full text-sm font-medium mb-6">
          <SparklesIcon className="h-4 w-4" />
          <span>Your Shortcut to Smart Shopping</span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6">
          Discover Deals.{" "}
          <span className="gradient-text">Share Smarter.</span>
        </h1>

        <p className="max-w-2xl mx-auto text-lg sm:text-xl text-gray-300 mb-8">
          Convert any Amazon link into your affiliate URL instantly, or explore our
          hand-picked categories to find your next favorite product.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a href="#converter" className="btn-primary inline-flex items-center justify-center">
            Start Converting Links
          </a>
          <a href="#categories" className="btn-secondary inline-flex items-center justify-center">
            Browse Categories
          </a>
        </div>
      </div>
    </section>
  );
}
